import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cvMarketplaceProductsFilter',
  pure: false
})
export class CvMarketplaceProductsFilterPipe implements PipeTransform {

  transform(items: any[]): any {
    if (!items) {
      return items;
    }
    let sortList = items.filter(item => item.showItem == true);

    return sortList;
  }

}
